"use strict";
// Themes: pure-data design packages (tokens + fonts + art direction) the Dunea
// AI applies to an app. Contract: themeManifestSchema in @dunea/plugin-sdk.
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFirstPartyTheme = exports.FIRST_PARTY_THEMES = void 0;
__exportStar(require("./types"), exports);
__exportStar(require("./css"), exports);
__exportStar(require("./brief"), exports);
var first_party_1 = require("./first-party");
Object.defineProperty(exports, "FIRST_PARTY_THEMES", { enumerable: true, get: function () { return first_party_1.FIRST_PARTY_THEMES; } });
Object.defineProperty(exports, "getFirstPartyTheme", { enumerable: true, get: function () { return first_party_1.getFirstPartyTheme; } });
